import { ErrorMessage, Field, Form, Formik, FormikValues } from "formik";
import React, { FC, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { deserialize, serialize } from "serializr";
import { Students } from "../../../models/StudentsModel/students.model";
import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";
import BoardService from "../../../services/CourseServices/BoardService/board.service";
import { BoardMetaModel } from "../../../models/CourseModels/BoardModel/board.model";
import { StudentCreateModel } from "../../../models/InstituteModel/students.model";
import StudentService from "../../../services/StudentService/student.service";
import { StudentValidationSchema } from "../../Institute/instituteFormValidation";
import UIModal from "../../../shared/components/UIModal";
import InputField from "../../../shared/components/InputField";
import DropdownField from "../../../shared/components/DropdownField";
import DatePickerField from "../../../shared/components/DatePickerField";
import { Input, Select } from "antd";
import { countryCodes } from "../../../shared/utils/countryCodes";

import './privateStudentForm.scss'

interface PrivateStudentFormProps {
  visible: boolean;
  closeHandler: () => void;
  data?: Students;
  refreshList: () => void;
  apiMethod: () => void;
}

const PrivateStudentForm: FC<PrivateStudentFormProps> = (props) => {
  const { visible, closeHandler, data, apiMethod } = props;
  const [initialValues, setInitialValues] = useState<any>();
  const formRef = useRef<any>();
  const [prefix, setPrefix] = useState<string>("+91");

  const [branchClassRoomsMeta, setBranchClassRoomsMeta] = useState<MetaModel[]>(
    []
  );
  const [loading, setLoading] = useState(false);
  const [boardsMeta, setBoardsMeta] = useState<any>([]);
  const [boards, setBoards] = useState<any>([]);

  const fetchBoards = () => {
    BoardService.getSelfRegisteredBoardsList(
      (response) => {
        let boardsMeta = deserialize(BoardMetaModel, response);

        setBoards(response);
        setBoardsMeta(boardsMeta);

      },
      () => {},
      () => {},
    );
  };

  const handleClassRooms = (boardId: any) => {
    let classRooms = boards.filter(
      (data: any) => data.id == boardId
    )[0]?.classRooms
    
    const meta = deserialize(MetaModel, classRooms) as MetaModel[];
    setBranchClassRoomsMeta(meta);
  };

  useEffect(() => {
    setInitialValues({
      id: data?.id,
      isBlocked: data?.isBlocked || false,
      firstName: data?.name,
      dob: data?.dob,
      email: data?.email,
      startDate: data?.startDate,
      endDate: data?.endDate,
      rollNumber: data?.rollNumber,
      boardId: data?.board?.id,
      courseId: data?.classRoom?.id,
      branchClassRoomId: data?.section?.branchClassRoomId,
      phoneNumber: data?.phoneNumber?.slice(-10),
      countryCode: data?.phoneNumber?.substring(0, -10) || "+91",
      password: "",
    });

    fetchBoards();

    if (data?.board?.id) {
      handleClassRooms(data?.board?.id)
    }
  }, [data]);


  const onSubmit = (values: FormikValues) => {
    setLoading(true);

    const jsonPayload = serialize(StudentCreateModel, {
      ...values,
      phoneNumber: values.countryCode + values.phoneNumber
    });
    if (data?.id) {
      StudentService.updatePrivateStudent(
        data?.id,
        jsonPayload,
        () => {
          formRef.current.resetForm({ values: null });
          closeHandler();
          apiMethod();
          setLoading(false);
        },
        (errors: any) => {
          // setUploadErrors(errors);
        },
        () => {
          setLoading(false);
        }
      );
    } else {
      StudentService.createPrivateStudent(
        jsonPayload,
        () => {
          formRef.current.resetForm({ values: null });
          closeHandler();
          apiMethod();
          setLoading(false);
        },
        (errors: any) => {
          // setUploadErrors(errors);
        },
        () => {
          setLoading(false);
        }
      );
      setLoading(false);
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
      innerRef={formRef}
      validationSchema={StudentValidationSchema}
    >
      {({ values, setFieldValue, resetForm, handleSubmit }) => (
        <UIModal
          visible={visible}
          closeModal={closeHandler}
          onClosed={resetForm}
          submitProps={{
            text: data ? "Update" : "Create",
            clickHandler: handleSubmit,
            buttonLoading: loading,
          }}
          cancelProps={{
            text: "Cancel",
            clickHandler: closeHandler,
          }}
          className="institute-student-form"
        >
          <Form
            placeholder={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          >
            <div className="institute-student-form__header">
              <div className="institute-student-form__title">
                {data ? "Update Student" : "Create New Student"}
              </div>
            </div>
            <div className="institute-student-form__input">
              <div className="institute-student-form__label">Student Name</div>
              <InputField type="text" name="firstName" placeholder="Enter" />
            </div>

            <div className="institute-student-form__input">
              <div className="institute-student-form__label">Email ID</div>
              <InputField type="text" name="email" placeholder="Enter" />
            </div>

            <div className="institute-student-form__input">
              <div className="institute-student-form__label">Roll Number</div>
              <InputField type="text" name="rollNumber" placeholder="Enter" />
            </div>
            {!values?.id && (
              <>
                <div className="institute-student-form__input">
                  <div className="institute-student-form__label">Board</div>
                  <DropdownField
                    name="boardId"
                    placeholder="Select board"
                    disabled={false}
                    options={boardsMeta}
                    value={values?.boardId}
                    onChange={(value) => {
                      setFieldValue("boardId", value);
                      handleClassRooms(value);
                    }}
                    showSearch={false}
                    optionFilterProp="label"
                  />
                </div>
                <div className="institute-student-form__input">
                  <div className="institute-student-form__label">Class</div>
                  <DropdownField
                    name="branchClassRoomId"
                    placeholder="Select"
                    disabled={false}
                    options={branchClassRoomsMeta}
                    value={values?.courseId}
                    onChange={(value) => {
                      setFieldValue("courseId", value);
                    }}
                    showSearch={false}
                    optionFilterProp="label"
                  />
                </div>

                <div className="institute-student-form__input">
                  <div className="institute-student-form__label">
                    Start Date
                  </div>
                  <DatePickerField
                    name="startDate"
                    placeholder="Select Date"
                    value={values?.startDate}
                    format="YYYY-MM-DD"
                    onSelect={(date) => {
                      setFieldValue("startDate", date?.format("YYYY-MM-DD"));
                    }}
                  />
                </div>
                <div className="institute-student-form__input">
                  <div className="institute-student-form__label">End Date</div>
                  <DatePickerField
                    name="endDate"
                    placeholder="Select Date"
                    value={values?.endDate}
                    format="YYYY-MM-DD"
                    onSelect={(date) => {
                      setFieldValue("endDate", date?.format("YYYY-MM-DD"));
                    }}
                  />
                </div>
              </>
            )}

            <div className="institute-student-form__input">
              <div className="institute-student-form__label">Phone Number</div>
              <Input.Group compact>
                <Select
                  showSearch
                  defaultValue={values?.countryCode}
                  style={{ width: "25%" }}
                  onChange={(value) => setFieldValue("countryCode", value)}
                  optionFilterProp="country"
                  filterSort={(optionA, optionB) =>
                    (optionA?.country ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.country ?? "").toLowerCase())
                  }
                  options={countryCodes}
                />

                <Field
                  as={Input}
                  style={{ width: "75%" }}
                  type="number"
                  name="phoneNumber"
                  placeholder="Mobile Number"
                  onChange={(e) => setFieldValue("phoneNumber", e.target.value)}
                />
              </Input.Group>
              <div className="input__error">
                <ErrorMessage name="phoneNumber" />
              </div>
            </div>
            <div className="institute-student-form__input">
              <div className="institute-student-form__label">Date of birth</div>
              <DatePickerField
                name="date"
                placeholder="Select Date"
                value={values?.dob}
                format="YYYY-MM-DD"
                onSelect={(date) => {
                  setFieldValue("dob", date?.format("YYYY-MM-DD"));
                }}
              />
            </div>
            {!values?.id && (
              <div className="institute-student-form__input">
                <div className="institute-student-form__label">Password</div>
                <InputField
                  type="text"
                  name="password"
                  placeholder="Enter password"
                />
              </div>
            )}
          </Form>
        </UIModal>
      )}
    </Formik>
  );
};

export default PrivateStudentForm;
